module.exports = __webpack_public_path__ + "static/stamp-749fa533ca3623c8e774ba00b14ab4ea.png";